import { UI } from '@leverege/ui-redux';
import { LOCATION_CHANGE } from 'connected-react-router';
export default {
  id: 'molten.cleanupOnPush',
  sort: Infinity,
  createMiddleware: molten => {
    return store => next => action => {
      const {
        ui: {
          expandedPathname
        }
      } = store.getState();
      if (action.type === LOCATION_CHANGE && action?.payload?.location?.pathname !== expandedPathname) {
        store.dispatch(UI.set('expanded', null));
        store.dispatch(UI.set('expandedPathname', null));
      }
      next(action);
    };
  }
};